/** The Ballast mark: a target line with one weight above it and one below,
 *  equal in mass so the composition balances. Rebuilt as vector so it stays
 *  sharp at favicon size, where a raster would turn to mud.
 *
 *  `id` must be unique per instance — two inline SVGs sharing a gradient id
 *  makes the second one render with the first one's fill.
 */
export function Logo({ size = 26, id = 'ballast-mark' }: { size?: number; id?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" role="img" aria-label="Ballast">
      <defs>
        <linearGradient id={id} x1="26" y1="0" x2="74" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#a3ff5b" />
          <stop offset="1" stopColor="#4de1ff" />
        </linearGradient>
      </defs>
      {/* weight above the line */}
      <rect x="44.5" y="29.5" width="12" height="16.5" rx="1.8" fill={`url(#${id})`} />
      {/* the target line */}
      <rect x="26" y="48" width="48" height="6" rx="3" fill={`url(#${id})`} />
      {/* weight below the line */}
      <rect x="51.5" y="56" width="11" height="15.5" rx="1.8" fill={`url(#${id})`} />
    </svg>
  )
}
